import axios from "axios";
import {
  buildSmsLinkMessage,
  buildSupportAppLinkFromWorkplace,
  isSmsMessageTooLong,
  smsLinkHasAttParam,
} from "./supportAppLink";

/**
 * 지원인력 행 목록에 지원앱 출근 링크 SMS 발송
 * @returns {{ ok: number, fail: number, skipped: number, missingAttLink: number, replyNum: string }}
 */
export async function sendSupportAppSmsLinks({
  apiAddr,
  dsid,
  dsnm = "",
  rows,
  replyNumber,
}) {
  const base = String(apiAddr || "").replace(/\/$/, "");
  const replyNum = (replyNumber || "").trim() || "033-249-5664";
  let ok = 0;
  let fail = 0;
  let skipped = 0;
  let missingAttLink = 0;

  for (const row of rows) {
    const pphone = String(row.pphone || "").trim();
    if (!pphone || (!row.rdvId && !row.siteId)) {
      skipped += 1;
      continue;
    }

    const attSnum = row.attSnum;
    const link = buildSupportAppLinkFromWorkplace({
      dsid,
      dsnm,
      workplaceName: row.workplace,
      rdvId: row.rdvId,
      siteId: row.siteId,
      forSms: true,
      attSnum,
    });
    const msg = buildSmsLinkMessage(link);
    if (
      attSnum != null &&
      attSnum !== "" &&
      !smsLinkHasAttParam(link)
    ) {
      missingAttLink += 1;
    }
    if (isSmsMessageTooLong(msg)) {
      fail += 1;
      continue;
    }

    const pnum = pphone.replace(/\D/g, "");
    try {
      const res = await axios.post(`${base}/post/sendcustomsms`, {
        pnum,
        callsgn: row.pname || "지원인력",
        msg,
        replyNumber: replyNum,
      });
      if (res.data?.result === "success") ok += 1;
      else fail += 1;
    } catch {
      fail += 1;
    }
  }

  return { ok, fail, skipped, missingAttLink, replyNum };
}
